import { clsx } from 'clsx';

type ProgressBarQuizProps = {
  current: number;
  total: number;
  className?: string;
};

export const ProgressBarQuiz = ({
  current,
  total,
  className,
}: ProgressBarQuizProps) => {
  const progress = (current / total) * 100;

  return (
    <div
      data-testid='quiz-progress-bar'
      className={clsx('flex flex-col gap-6', className)}
    >
      <span className='body'>{`${current}/${total}`}</span>
      <div className='bg-blue-500/20 w-full h-2 md:h-[2px] relative overflow-hidden rounded-lg'>
        <div
          className='absolute h-full left-0 bg-blue-500 duration-200 ease-in-out rounded-lg'
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
